import { render, staticRenderFns } from "./FormAsetuksetPaamiesosoite.vue?vue&type=template&id=693a6492&scoped=true&"
import script from "./FormAsetuksetPaamiesosoite.vue?vue&type=script&lang=js&"
export * from "./FormAsetuksetPaamiesosoite.vue?vue&type=script&lang=js&"
import style0 from "./FormAsetuksetPaamiesosoite.vue?vue&type=style&index=0&id=693a6492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693a6492",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCol,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('693a6492')) {
      api.createRecord('693a6492', component.options)
    } else {
      api.reload('693a6492', component.options)
    }
    module.hot.accept("./FormAsetuksetPaamiesosoite.vue?vue&type=template&id=693a6492&scoped=true&", function () {
      api.rerender('693a6492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormAsetuksetPaamiesosoite.vue"
export default component.exports